import { useMemo } from 'react';
import { Form } from '../types/form';

export interface FilterOptions {
  searchQuery: string;
  statusFilter: 'all' | 'published' | 'draft';
  sortBy: 'updated' | 'created' | 'name';
}

export const useFormFiltering = (forms: Form[], options: FilterOptions) => {
  return useMemo(() => {
    const { searchQuery, statusFilter, sortBy } = options;
    
    let filtered = forms.filter(form => {
      const matchesSearch = !searchQuery || 
        form.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
        form.description?.toLowerCase().includes(searchQuery.toLowerCase());
      
      const matchesStatus = statusFilter === 'all' || 
        (statusFilter === 'published' && form.is_published) ||
        (statusFilter === 'draft' && !form.is_published);
      
      return matchesSearch && matchesStatus;
    });

    filtered.sort((a, b) => {
      switch (sortBy) {
        case 'name':
          return a.title.localeCompare(b.title);
        case 'created':
          return new Date(b.created_at).getTime() - new Date(a.created_at).getTime();
        case 'updated':
        default:
          return new Date(b.updated_at).getTime() - new Date(a.updated_at).getTime();
      }
    });

    return filtered;
  }, [forms, options]);
};